export const COUNTERPARTY_TAGS_LIST_PATH = "/counterparty-tags";
